import { render, staticRenderFns } from "./vendors_address.vue?vue&type=template&id=8a387996&scoped=true&"
import script from "./vendors_address.vue?vue&type=script&lang=js&"
export * from "./vendors_address.vue?vue&type=script&lang=js&"
import style0 from "./vendors_address.vue?vue&type=style&index=0&id=8a387996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a387996",
  null
  
)

export default component.exports